export default function search() {

    let mag = document.querySelector('.magnifying-glass svg');
    mag.addEventListener("click", function () {
        let searchContainer = mag.parentNode.querySelector('.search-input-container');
        this.parentNode.classList.toggle("active");

        if (searchContainer.style.maxHeight) {
            searchContainer.style.maxHeight = null;
        } else {
            searchContainer.style.maxHeight = searchContainer.scrollHeight + "px";
        }
    });
}